module.exports = __webpack_public_path__ + "c5d2e51636d5b3bf307d9b0bff6fce59.svg";